export const MODE = 'LOCALHOST' //LOCALHOST OR PRO

export const API_URL_PRO = '/'

export const TIME_EXPIRED_TRIES = 60;

export const API_URL_DEV = '/'
